export const CONNECT_STORE_STATE_UNCONNECTED = 'unconnected'
export const CONNECT_STORE_STATE_CHECK_FAILED = 'check_failed'
export const CONNECT_STORE_STATE_SUCCESS = 'success'
